import { Box, TextField, Typography } from "@mui/material";
import { ScrapEyesEvent } from "components/scrapEyeLabelling/types";
import { useTenantTranslation } from "hooks/formatters";

interface CommentSectionProps {
  event: ScrapEyesEvent;
  onChange: (updates: Partial<ScrapEyesEvent>) => void;
}

export const CommentSection = ({ event, onChange }: CommentSectionProps) => {
  const { t } = useTenantTranslation();

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1.5 }}>
        {t("comment")}
      </Typography>
      <TextField
        fullWidth
        multiline
        rows={3}
        value={event.comment ?? ""}
        onChange={(e) => {
          onChange({ comment: e.target.value || undefined });
        }}
        placeholder={t("addCommentOptional")}
        variant="outlined"
        size="small"
      />
    </Box>
  );
};
